import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import VueMeta from 'vue-meta'
import store from '@/state/store'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

const router = new VueRouter({
  routes,
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
});

// Before each route evaluates...
router.beforeEach((to, from, next) => {
  store.dispatch('layout/changeOverwritePageTitle', {title: ''});
  const permissions = store.state.permissions;
  const isAuthenticated = store.state.auth.token;
  const user = store.state.auth.user;

  // console.log('router/index.js permissions: ' + JSON.stringify(permissions));
  // console.log('router/index.js permissions menu_accessible: ' + (permissions.menu_accessible != null));
  // console.log('isAuthenticated: ' + isAuthenticated);

  from.params.previousRoute = {};
  const metaTo = to.meta(to);
  //screen has to be in user permission to access and screen must exist
  const isScreenCannotAccess = permissions?.screen_accessible?.find(item => item.url == metaTo?.url) === undefined && metaTo?.url !== undefined

  const mustLogout = (permissions) => {
    //user must force to logout when ... =>
    let is_screen_and_menu_not_exist = !permissions.screen_accessible || !permissions.menu_accessible
    let is_menu_blank = permissions.menu_accessible && permissions.menu_accessible.length < 1;
    let is_screen_blank = permissions.screen_accessible && permissions.screen_accessible.length < 1;

    if (is_screen_and_menu_not_exist || is_menu_blank || is_screen_blank) {
      return true
    }

    return false
  }

  if (mustLogout(permissions) && isAuthenticated) {
    console.log('router/index.js mustLogout ログアウト');
    store.dispatch("auth/logout");
  }

  // 認証が必要か？
  if (metaTo && metaTo.authRequired) {
    // 認証済みか？
    if (isAuthenticated) {
      to.params.previousRoute = from;
      // metaTo.roleAuthIgnoreが設定されておらず、cannotAccessの場合404へ飛ばす
      if (!(metaTo.roleAuthIgnore)) { 
        if (isScreenCannotAccess) return next('/404');
      } else if(!metaTo.roleAuthIgnore.includes(-1) && !metaTo.roleAuthIgnore.includes(user.authorization_type_id)){
        //metaTo.roleAuthIgnoreが設定されており、認証除外に-1がなく、に小タイプが除外対象にも含まれておらず、cannotの場合404
        if (isScreenCannotAccess) return next('/404');
      }
      return next();
    }
    // 認証が必要で認証済みでない場合ログイン処理へ飛ばす
    return next('/login');
  }

  if (to.name === 'login' && isAuthenticated) {
    return next('/');
  }

  next();
})

export default router
